import React from "react"
import FadeIn from "../general/fadein.tsx"
import FadeInTop from "../general/fadeintop.tsx"
import powerplay from "../../images/powerplay/powerplay_large.png"
import robot from "../../images/powerplay/robot.png"
import junction from "../../images/powerplay/junction.png"
import teamprop from "../../images/powerplay/teamprop.png"
import cone from "../../images/powerplay/cone.png"
import successfulauto from "../../images/powerplay/successfulauto.png"
import scoredcones from "../../images/powerplay/scoredcone.png"
import beacon from "../../images/powerplay/beacon.png"
import portfolio from "../../images/powerplay/portfolio.pdf"
import meepmeep from "../../images/powerplay/meepmeep.png"

function PowerPlay() {

    const transition = {
        transition: ".3s"
    }
    const brief_description = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">This Season's Game</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">An FTC game is divided into three stages. Autonomous where the robot runs itself. Tele-Op where two human drivers control the robot. And Endgame where the robot gets additional tasks that are worth lots of points.
            <br></br><br></br>Below are two important terms for this seasons game. The main scoring object is to place cones on junctions of varying heights.
        </p>
        <div className="flex flex-row ">
            <div className="flex flex-col mr-4">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Cone</p>
                <img
                    className=" h-36 rounded-md object-fill object-center"
                    src={cone}
                    alt="Cone"
                />
            </div>
            <div className="flex flex-col">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Junction</p>
                <img
                    className=" rounded-md object-fill object-center"
                    src={junction}
                    alt="Junction"
                />
            </div>
        </div>
    </div>)
    const robot_picture = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-5 text-center font-semibold">Our Robot</p>
        <br></br>
        <img
            className="rounded-md object-fill object-center"
            src={robot}
            alt="Robot"
        />
    </div>)
    const autonomous_section = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Autonomous</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">At the start of Autonomous, our robot identifies our Team Prop which instructs the code which of the three paths to follow. <br></br>
            <br></br>If the autonomous is successful, our robot will end up parked in one of three zones depending on the team prop and several cones will have been placed on various junctions for double autonomous points.</p>
        <div className="flex flex-row ">
            <div className="flex flex-col mr-4">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Team Prop</p>
                <img
                    className=" h-36 rounded-md object-fill object-center"
                    src={teamprop}
                    alt="Team Prop"
                />
            </div>
            <div className="flex flex-col">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Successful Autonomous</p>
                <img
                    className=" rounded-md object-fill object-center"
                    src={successfulauto}
                    alt="Successful Autonomous"
                />
            </div>
        </div>
    </div>);
    

    const tele_op_description = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Tele-Op</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">During the Tele-Op period, the human drivers navigate the field while collecting and placing cones on junctions of various heights. </p>
        <div className="flex flex-row ">
            <div className="flex flex-col ">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Scored Cones</p>
                <img
                    className=" rounded-md object-fill object-center"
                    src={scoredcones}
                    alt="Scored Pixels"
                />
            </div>
        </div>
    </div>)
    const endgame_description = (<div>
        <div className="flex flex-col items-center ">
            <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Endgame</p>

            <p className="text-xl w-4/5 pt-4 text-left font-light">During the Endgame period, there are two new tasks introduced, connect a line of cones from one corner of the field to another and place a special "beacon" to lock and claim and junction for your team. </p>

        </div>
        <div className="flex flex-row pl-16">
            <div className="flex flex-col">
                <div className="flex flex-row pt-5">
                    <div>
                        <p className="text-2xl pt-5 font-semibold">Beacon</p>
                        <p className="text-xl font-light">Our beacon for the PowerPlay season was a crown that sat on top of a cone to be scored with maximum points.</p>
                    </div>
                    <img
                        className=" rounded-md object-fill object-center"
                        src={beacon}
                        alt="Beacon"
                    />
                </div>
            </div>
        </div>

    </div>)
    const coding_description = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Coding</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">In order for the code to be efficient and usable, I used a Finite State Machine to manage different states of the robot at the same time. This way the robot can drive and the slides can operate at the same time without holding up the loop times. </p>
        <div className="flex flex-row pl-16">
            <div className="flex flex-col">
                <div className="flex flex-row pt-5 items-center">
                    <div>
                        <p className="text-2xl pt-5 font-semibold">Roadrunner</p>
                        <p className="text-xl font-light">In order to take advantage of the Mecanum wheels on our robot, we use the Roadrunner pathing library to create complex spline paths.</p>
                    </div>
                    <img
                        className=" rounded-md object-fill object-center"
                        src={meepmeep}
                        alt="MeepMeep"
                    />
                </div>
            </div>
        </div>
    </div>)
    
    const top = (<div className="grid grid-cols-2 w-2/3 m-auto mt-5 ">
        <div className="text-center m-auto p-5 ">
            <img
                className=" h-96 w-96 rounded-full object-fill object-center"
                src={powerplay}
                alt="CenterStage Logo"
            />

        </div>
        <div className="flex flex-row text-left  p-5 items-center">
            <div>
                <h1 className="text-3xl sm:text-5xl font-semibold">FTC PowerPlay</h1>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://github.com/Shyiu/FTCPowerPlay">GitHub</a><br></br>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href={portfolio} target="_blank" rel="noreferrer">Engineering Portfolio</a>
                <p className="text-l sm:text-2xl">I programmed our robot this season in Java. We earned the 3rd Place Inspire Award for being the model FTC Team at our Regional Qualifiers and earned the 2nd Place Think Award for our engineering portfolio.</p>
            </div>
        </div>
    </div>)
    return (
        <>
            <div className="divide-y divide-black/50 w-3/4 m-auto">
                <FadeInTop html={top}/>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={brief_description} left={true} />
                    <FadeIn html={robot_picture} left={false} />
                </div>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={autonomous_section} left={true} />
                    <FadeIn html={tele_op_description} left={false} />
                </div>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={endgame_description} left={true} />
                    <FadeIn html={coding_description} left={false} />
                </div>
            </div>
        </>
    );
}
export default PowerPlay;